__turbopack_context__.v({
  "ctaButtons": "Itineraries-module__17ulxa__ctaButtons",
  "ctaContainer": "Itineraries-module__17ulxa__ctaContainer",
  "grid": "Itineraries-module__17ulxa__grid",
  "headingWrapper": "Itineraries-module__17ulxa__headingWrapper",
  "itineraryCard": "Itineraries-module__17ulxa__itineraryCard",
  "seeMoreButton": "Itineraries-module__17ulxa__seeMoreButton",
  "subtitle": "Itineraries-module__17ulxa__subtitle",
});
